import React, { Component } from "react";
import "./Landing.css"
import { GrWorkshop } from "react-icons/gr";
import { PiCertificate } from "react-icons/pi";
import { FaRegChartBar } from "react-icons/fa";
import LandingFooter from "../part/landing.footer";
import FloatingContact from "../part/floating.contact";
import FooterRight from "../part/landing.footer.right";
import LandingSearchHeader from "../part/header_search";
import { Link } from "react-router-dom"
import Empty from "../image/empty.svg"
import axios from "axios";
import FilterCourse from "../part/filter_bar_course";
import LoadingError from "../part/loading_error";
// import NumberDisplay from "../part/currencyValue";
// import { PiCurrencyNgn } from "react-icons/pi";

class LandCourse extends Component {
    state = {
        topic: [
            { id: "1", head: "Beginners to Intermediate GIS Class", cost: "#140,000", course: "GIS", icon: <GrWorkshop /> },
            { id: "2", head: "Drone Pilot for Beginners", cost: "#300,000", course: "Drone", icon: <PiCertificate /> },
            { id: "3", head: "Beginners to Advanced GIS Class", cost: "#450,000", course: "GIS", icon: <FaRegChartBar /> },
            { id: "4", head: "Drone Pilot for Beginners to Professional", cost: "#450,000", course: "Drone", icon: <GrWorkshop /> },
            { id: "5", head: "GIS and Remote Sensing for Agriculture", cost: "#550,000", course: "GIS", icon: <PiCertificate /> },
            { id: "6", head: "Remote Sensing and Google Earth Engine (Level 1)", cost: "#150,000", course: "Remote Sensing", icon: <FaRegChartBar /> },
            { id: "7", head: "Digital Soil Mapping", cost: "#400,000", course: "GIS", icon: <GrWorkshop /> },
            { id: "8", head: "Remote Sensing and Google Earth Engine - (Level 2)", cost: "#200,000", course: "Remote Sensing", icon: <PiCertificate /> },
            { id: "9", head: "GIS and Remote Sensing for Agriculture ", cost: "#550,000", course: "GIS", icon: <FaRegChartBar /> },
            { id: "10", head: "AutoCAD For Surveying and Mapping", cost: "#300,000", course: "Survey", icon: <GrWorkshop /> },
            { id: "12", head: "GIS and Remote Sensing for Maritime", cost: "#550,000", course: "GIS", icon: <PiCertificate /> },
            { id: "13", head: "Differential GPS (DGPS) Land Surveying Training ", cost: "#450,000", course: "Survey", icon: <FaRegChartBar /> },
            { id: "14", head: "GIS with Python in ArcGIS Beginners - Intermediate", cost: "#120,000", course: "GIS", icon: <GrWorkshop /> },
            { id: "15", head: "WORKSHOP AND SEMINAR", cost: "Free", course: "All", icon: <PiCertificate /> },
            { id: "16", head: "Online Scripting in ArcGIS - Advanced", cost: "#140,000", course: "GIS", icon: <FaRegChartBar /> },
            { id: "17", head: "Spatial Analysis using ArcGIS", cost: "#150,000", course: "GIS", icon: <FaRegChartBar /> },
            { id: "18", head: "Managing Geospatial Data in ArcGIS", cost: "#150,000", course: "GIS", icon: <GrWorkshop /> },
            { id: "19", head: "Image analysis with ArcGIS", cost: "#150,000", course: "GIS", icon: <PiCertificate /> },
            { id: "20", head: "GIS Field data collection and management", cost: "#150,000", course: "GIS", icon: <FaRegChartBar /> },

        ],
        activePage: 0,
        autoSlideEnabled: true,
        activeGoalId: null,
        selectedCourse: "All",
        course: [],
        filter_type_name: "Type",
        filter_level_name: "Level",
        filter_status_name: "Status",
        loading : false


    }
    componentDidMount() {
        this.fetchCourses()
    }
    fetchCourses = async () => {
        this.setState({loading : true})
        const accessToken = localStorage.getItem("accessToken");

        try {
            let headers = {}; // Initialize an empty headers object

            if (accessToken) {
                headers = {
                    Authorization: `Bearer ${accessToken}`,
                };
            }

            const response = await axios.get("https://api.geoinfoacademy.com/api/courses/", {
                headers: headers,
            });
            this.setState({ course: response.data , loading : false});
            console.log("API Response:", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
            this.setState({loading : false})
        }
    };



    // the filter start here 
    initialfilterbytype = () => {
        const courses = this.state.course;
        if (this.state.filter_type_name === "Type" || this.state.filter_type_name === "All") {
            return courses
        } else {
            return courses.filter((item) => item.labels === this.state.filter_type_name);

        }
    };

    initialfilterbylevel = () => {
        const courses = this.initialfilterbytype();

        if (this.state.filter_level_name === "Level" || this.state.filter_level_name === "All") {
            return courses
        } else if (this.state.filter_level_name === "Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Advance" ||
                    item.tags === "Professional"
            );
        } else if (this.state.filter_level_name === "Beginner to Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Beginner to Advance" ||
                    item.tags === "Beginner to Professional"
            );
        }

        else {
            return courses.filter((item) => item.tags === this.state.filter_level_name);

        }
    };
    initialfilterbystatus = () => {
        const courses = this.initialfilterbylevel();
        if (this.state.filter_status_name === "Status" || this.state.filter_status_name === "All") {
            return courses
        } else if (this.state.filter_status_name === "Online") {
            return courses.filter(
                (item) =>
                    item.training_type === "Online Prerecorded" ||
                    item.training_type === "Online Live with Facilitator"
            );
        }
        // If "Physical" is selected, filter for "general physical class" and "private physical class"
        else if (this.state.filter_status_name === "Physical") {
            return courses.filter(
                (item) =>
                    item.training_type === "General Physical Class" ||
                    item.training_type === "Physical Private Class"
            );
        }
        // Default case: If filter_level_name matches a specific training_type directly
        else {
            return courses.filter(
                (item) => item.training_type === this.state.filter_status_name
            );
        }
    };
    handleFilterChange = (filterType, filterLevel, filterStatus) => {
        this.setState({
            filter_type_name: filterType,
            filter_level_name: filterLevel,
            filter_status_name: filterStatus,
        })
    };

    render() {
        // const { course } = this.state 
        function slugify(text) {
            return text.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
        }
        const courses = this.initialfilterbystatus()
        const dropdown_topic = courses.length ?
            courses.map(list => {
                return (
                    <section className="landing_topic width " key={list.id}>
                        <Link to={`/Landing_description/${list.id}/${slugify(list.title)}`}>
                            <div className="course_video">
                                <img src={list.thumbnail} alt={"course" + list.id} />
                            </div>
                            <div className="course_Writeup">
                                <h4>
                                    <span>{list.labels}</span>
                                    <br />
                                    {list.title}
                                </h4>
                                {/* <p><PiCurrencyNgn /> <NumberDisplay value={list.price}/></p> */}
                            </div>
                        </Link>
                    </section>
                )
            }) : (<div className="no_course">
                <div className="image">
                    <img src={Empty} alt="no course" />
                </div>
                <br />
                <p>No Available Course </p>
            </div>)




        return (
            <div className="body">
                <LandingSearchHeader />
                <div className="landing_video">
                    <h3>All Courses</h3>
                    <div style={{ width: "100%", height: "auto", backgroundColor: "white", position: "sticky", top: "0px", paddingTop: "10px", zIndex: "3" }}>
                        <FilterCourse
                            filterType={this.state.filter_type_name} // Pass current values as props
                            filterLevel={this.state.filter_level_name}
                            filterStatus={this.state.filter_status_name}
                            onFilterChange={this.handleFilterChange}
                            ref={(el) => this.filterRef = el}
                        />
                    </div>
                    <div className="landing_course">

                        <div className="landing_allcourse page" >
                            {dropdown_topic}
                        </div>

                    </div>
                </div>

                <FloatingContact />
                <LandingFooter />
                <FooterRight />
                {this.state.loading  ? <LoadingError /> : null}

            </div>
        )
    }
}
export default LandCourse